__turbopack_context__.v({
  "popularBrandsWrapper": "htT3Yq_popularBrandsWrapper",
  "resultsTotalCount": "htT3Yq_resultsTotalCount",
  "wrapper": "htT3Yq_wrapper",
});
